import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { MatCard } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-formly-wrapper-mat-card',
  templateUrl: './formly-wrapper-mat-card.component.html',
  styleUrls: ['./formly-wrapper-mat-card.component.scss'],
  imports: [MatCard, TranslateModule],
})
export class FormlyWrapperMatCardComponent extends FieldWrapper {}
